import styled from "styled-components";
import { variant } from "styled-system";
import Text from "../text/Text";
import Flex from "../box/Flex";
import { apolloSpaceInlineHalfX, apolloSpaceInline1X } from "@nexthink/apollo-tokens";
const sliderHeightSmall = 12;
const sliderWidthSmall = 20;
const sliderHeightLarge = 16;
const sliderWidthLarge = 28;
const margin = 2;
export const StyledLabel = styled(Text).withConfig({ displayName: "StyledLabel_APC-7281-productShell", componentId: "sc-bdvlqu" })(({ disabled, theme }) => ({
    color: disabled ? theme.colors.apolloColorTextDisabled : theme.colors.apolloColorTextPrimary,
}), () => variant({
    prop: "toggleSize",
    variants: {
        small: {
            marginRight: apolloSpaceInlineHalfX,
        },
        large: {
            marginRight: apolloSpaceInline1X,
        },
    },
}));
export const StyledToggleContainer = styled(Flex).withConfig({ displayName: "StyledToggleContainer_APC-7281-productShell", componentId: "sc-qv5h40" })(({ theme, focused }) => ({
    overflow: focused ? "clip" : "visible",
    border: focused ? `1px solid ${theme.colors.apolloColorStrokeFocus}` : `1px solid transparent`,
    "& input": {
        height: 0,
        margin: 0,
        opacity: 0,
        position: "absolute",
        width: 0,
    },
}));
export const StyledSlider = styled.span.withConfig({ displayName: "StyledSlider_APC-7281-productShell", componentId: "sc-nayy4o" })(({ checked, theme, disabled }) => (Object.assign(Object.assign({ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, borderRadius: "8px", boxShadow: theme.colors.apolloBoxShadowFormElement, transition: ".4s" }, (disabled
    ? {
        backgroundColor: theme.colors.apolloColorFillFormElementDefaultDisabled,
        border: `1px solid ${theme.colors.apolloColorStrokeToggleDisabled}`,
    }
    : {
        backgroundColor: theme.colors.apolloColorFillFormElementDefault,
        border: `1px solid ${theme.colors.apolloColorStrokeToggleDefault}`,
        cursor: "pointer",
    })), { "&::before": Object.assign({ borderRadius: "50%", position: "absolute", content: `""`, left: checked ? -1 - margin : -1, bottom: -1, transition: ".4s" }, (disabled
        ? {
            border: `1px solid ${theme.colors.apolloColorStrokeToggleDisabled}`,
            backgroundColor: theme.colors.apolloColorBackgroundToggleKnobDisabled,
        }
        : {
            border: `1px solid ${theme.colors.apolloColorStrokeToggleDefault}`,
            backgroundColor: theme.colors.apolloColorBackgroundToggleKnob,
        })) })), () => variant({
    prop: "toggleSize",
    variants: {
        small: {
            "&::before": {
                height: sliderHeightSmall - margin,
                width: sliderHeightSmall - margin,
            },
        },
        large: {
            "&::before": {
                height: sliderHeightLarge - margin,
                width: sliderHeightLarge - margin,
            },
        },
    },
}));
export const StyledToggleSwitchContainer = styled.div.withConfig({ displayName: "StyledToggleSwitchContainer_APC-7281-productShell", componentId: "sc-dwfqmo" })(({ theme, disabled }) => ({
    position: "relative",
    display: "inline-block",
    [`&[data-checked=true] ${StyledSlider}`]: {
        backgroundColor: disabled
            ? theme.colors.apolloColorBackgroundFormElementSelectedDisabled
            : theme.colors.apolloColorBackgroundFormElementSelected,
        border: `1px solid ${disabled
            ? theme.colors.apolloColorBackgroundFormElementSelectedDisabled
            : theme.colors.apolloColorBackgroundFormElementSelected}`,
        "&::before": {
            border: `1px solid ${disabled
                ? theme.colors.apolloColorBackgroundFormElementSelectedDisabled
                : theme.colors.apolloColorBackgroundFormElementSelected}`,
        },
    },
}), () => variant({
    prop: "size",
    variants: {
        small: {
            width: sliderWidthSmall,
            height: sliderHeightSmall,
            [`&[data-checked=true] ${StyledSlider}`]: {
                "&::before": {
                    transform: `translateX(${sliderHeightSmall - margin}px)`,
                },
            },
        },
        large: {
            width: sliderWidthLarge,
            height: sliderHeightLarge,
            [`&[data-checked=true] ${StyledSlider}`]: {
                "&::before": {
                    transform: `translateX(${sliderHeightLarge - margin}px)`,
                },
            },
        },
    },
}));
//# sourceMappingURL=Toggle.style.js.map